import React from 'react';
import { string } from 'prop-types';
import IconOk from 'icons/location-active.inline.svg';
import IconWarning from 'icons/location-active-warning.inline.svg';
import cx from 'classnames';
import deviceStatus from 'propTypes/deviceStatus';

import styles from './location-status-icon.scss';

function getIconForStatus(status, className) {
  const classes = cx(styles.main, className);

  switch (status) {
    case 'ok':
      return <IconOk className={classes} />;
    case 'warning':
    case 'disconnected':
      return <IconWarning className={classes} />;
    default:
      return (
        <span className={classes}>
          {`Invalid status ${status}`}
        </span>
      );
  }
}

export default function LocationStatusIcon({ status, className }) {
  return getIconForStatus(status, className);
}

LocationStatusIcon.propTypes = {
  status: deviceStatus.isRequired,
  className: string,
};



// WEBPACK FOOTER //
// ./src/components/LocationStatusIcon/index.js